"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.processStyleFetch = exports.processStyleUpdate = void 0;
const camelcase_keys_1 = __importDefault(require("camelcase-keys"));
const lodash_mapvalues_1 = __importDefault(require("lodash.mapvalues"));
function processStyleUpdate(resp) {
    resp.data = (0, camelcase_keys_1.default)(resp.data, { deep: true, stopPaths: ['result.symbols'] });
    const { symbols } = resp.data.result;
    resp.data.result.symbols = (0, lodash_mapvalues_1.default)(symbols, val => (0, camelcase_keys_1.default)(val));
}
exports.processStyleUpdate = processStyleUpdate;
const processStyleFetch = (resp) => {
    resp.data.result = resp.data.result.map((style) => {
        const exceptSymbols = (0, camelcase_keys_1.default)(style, { deep: true, stopPaths: ['result.symbols'] });
        const updatedSymbols = (0, lodash_mapvalues_1.default)(style.symbols, val => (0, camelcase_keys_1.default)(val));
        return Object.assign(Object.assign({}, exceptSymbols), { symbols: updatedSymbols });
    });
};
exports.processStyleFetch = processStyleFetch;
//# sourceMappingURL=style.js.map